import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { VerticalConfig } from '../../interfaces/vertical-config.interface';

export interface VerticalOverride {
  vertical: string;
  vertical_config: VerticalConfig;
}

// The sa_vertical_override cookie lets a superadmin preview the app through another
// vertical's lens for the current session. It stores the chosen vertical key plus that
// vertical's terminology (vertical_config), fetched from the superadmin-only backend
// endpoint when the vertical is selected. On context init the FE inserts the stored
// vertical_config into the agency and company context, so a reload re-applies the lens.
// The cookie is short-lived (24h) and purely client-side — the backend never reads or
// manages it.
@Injectable({
  providedIn: 'root',
})
export class VerticalOverrideCookieService {
  private static readonly COOKIE_NAME = 'sa_vertical_override';

  constructor(private cookieService: CookieService) {}

  public getOverride(): VerticalOverride | null {
    if (!this.cookieService.check(VerticalOverrideCookieService.COOKIE_NAME)) {
      return null;
    }
    try {
      return JSON.parse(
        this.cookieService.get(VerticalOverrideCookieService.COOKIE_NAME)
      );
    } catch {
      return null;
    }
  }

  public hasOverride(): boolean {
    return this.cookieService.check(VerticalOverrideCookieService.COOKIE_NAME);
  }

  // Add cookie that will expire in 24hrs
  public setOverride(vertical: string, verticalConfig: VerticalConfig): void {
    const payload: VerticalOverride = {
      vertical,
      vertical_config: verticalConfig,
    };
    this.cookieService.set(
      VerticalOverrideCookieService.COOKIE_NAME,
      JSON.stringify(payload),
      new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      '/'
    );
  }

  public clearOverride(): void {
    this.cookieService.delete(VerticalOverrideCookieService.COOKIE_NAME, '/');
  }
}
